var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { title: _vm.name } }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticStyle: { width: "100%" },
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _vm._l(_vm.sourceTypeValues, function (sourceType) {
            return _c(
              "v-card",
              { key: `form-${sourceType}` },
              [
                _c("Subheader", {
                  attrs: {
                    title: _vm.getSourceTypeName(sourceType),
                    "no-search": "",
                  },
                }),
                _vm._v(" "),
                _c(
                  "v-card-text",
                  [
                    _vm._v("\n        Grouper Order:\n        "),
                    _c(
                      "v-menu",
                      {
                        attrs: { "offset-y": "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g({}, on),
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.sideMenuSettingData[sourceType]
                                              .OrderType
                                          ) +
                                          "\n              "
                                      ),
                                      _c(
                                        "v-icon",
                                        { attrs: { small: "", right: "" } },
                                        [_vm._v("keyboard_arrow_down")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-tile",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.sideMenuSettingData[
                                      sourceType
                                    ].OrderType = "ASC"
                                  },
                                },
                              },
                              [_c("v-list-tile-title", [_vm._v("ASC")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.sideMenuSettingData[
                                      sourceType
                                    ].OrderType = "DESC"
                                  },
                                },
                              },
                              [_c("v-list-tile-title", [_vm._v("DESC")])],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-card-text",
                  { staticClass: "pt-0" },
                  [
                    _vm._v("\n        Grouper Type\n        "),
                    _c("v-combobox", {
                      attrs: {
                        items: _vm.getGroupTypeListBySourceType(sourceType),
                        solo: "",
                        chips: "",
                        label: "Select grouping",
                        multiple: "",
                        rules: _vm.GroupTypeRule,
                        "persistent-hint": "",
                        hint: "The label order is the grouping order",
                        "item-text": "name",
                        "item-value": "value",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selection",
                            fn: function (data) {
                              return [
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "chip--select-multi",
                                    attrs: {
                                      selected: data.selected,
                                      close: "",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.removeGroupTypeForSourceType(
                                          sourceType,
                                          data.item
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(data.item.name || data.item))]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.sideMenuSettingData[sourceType].GroupType,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.sideMenuSettingData[sourceType],
                            "GroupType",
                            $$v
                          )
                        },
                        expression: "sideMenuSettingData[sourceType].GroupType",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  staticClass: "centerBtn",
                  attrs: {
                    color: "success",
                    loading: _vm.isLoadingUpdate,
                    disabled: !_vm.valid,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.updateUserGroupSideMenuSetting()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("Button.Save")) + "\n      "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }